
import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import _ from "lodash";
import CloseIcon from "../../assets/svgIcons/CloseIcon";
import HelpIcon from "assets/svgIcons/HelpIcon";
import { HelpContainer } from "commonComponents/Navbar/NavbarStyled";
import { useTranslation } from "react-i18next";

export const HeaderLeftSection = ({
  logo,
  version,
  sideDrawerState,
  onClickSideBar,
  OpenUrl
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        sx={{
          height: "100%",
          background: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: "0", sm: "0 15px" },
        }}
      >
        <Tooltip
          className="tooltip"
          title={`${t("VCC_Version_Number")} ${version}`}
        >
          <img className="logo" src={logo} alt="logo" />
        </Tooltip>
      </Box>

      <Box
        sx={{
          borderRight: "1px solid #E5E5E5",
          height: "100%",
        }}
      />

      <Box
        sx={{
          height: "100%",
          paddingLeft: "10px",
          display: "flex",
          alignItems: "center",
          background: "#fff",
        }}
      >
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={onClickSideBar}
        >
          {sideDrawerState ? <CloseIcon /> : <MenuIcon color="#636F7C" />}
        </IconButton>
      </Box>

      <Box
        sx={{
          borderRight: "1px solid #E5E5E5",
          height: "100%",
        }}
      />

      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          padding: "0 12px",
          height: "100%",
          background: "#fff",
        }}
      >
        <Tooltip title={t("Get_help")} placement="right" arrow>
          <HelpContainer>
            <IconButton onClick={OpenUrl}>
              <HelpIcon style={{ cursor: "pointer" }} />

              <Typography
                variant="body2"
                sx={{
                  display: { xs: "none", md: "flex" },
                  marginLeft: "5px",
                }}
              >
                {t("Help")}
              </Typography>
            </IconButton>
          </HelpContainer>
        </Tooltip>
      </Box>
    </>
  );
};